const COOKIE_NAME = 'karamel_cookie_consent';
const COOKIE_DAYS = 365;

function getCookie(name) {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[.$?*|{}()[\]\\/+^]/g, '\\$&') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
}

function setCookie(name, value, days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    const secure = window.location.protocol === 'https:' ? '; Secure' : '';

    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires.toUTCString()}; path=/; SameSite=Lax${secure}`;
}

function hideCookieNotice(cookieNotice) {
    cookieNotice.setAttribute('hidden', '');
}

function acceptCookieNotice(cookieNotice) {
    setCookie(COOKIE_NAME, '1', COOKIE_DAYS);
    hideCookieNotice(cookieNotice);
}

function initCookieNotice() {
    const cookieNotice = document.querySelector('[data-cookie-notice]');

    if (!cookieNotice) {
        return;
    }

    if (getCookie(COOKIE_NAME) === '1') {
        cookieNotice.remove();
        return;
    }

    const acceptBtn = cookieNotice.querySelector('[data-cookie-notice-accept]');
    const closeBtn = cookieNotice.querySelector('[data-cookie-notice-close]');
    const ageGate = document.querySelector('[data-age-gate]');

    const showNotice = () => {
        cookieNotice.removeAttribute('hidden');
    };

    if (ageGate && !ageGate.hasAttribute('hidden')) {
        const ageGateObserver = new MutationObserver(() => {
            if (ageGate.hasAttribute('hidden')) {
                showNotice();
                ageGateObserver.disconnect();
            }
        });

        ageGateObserver.observe(ageGate, { attributes: true, attributeFilter: ['hidden'] });
    } else {
        showNotice();
    }

    acceptBtn?.addEventListener('click', () => {
        acceptCookieNotice(cookieNotice);
    });

    closeBtn?.addEventListener('click', () => {
        acceptCookieNotice(cookieNotice);
    });
}

document.addEventListener('DOMContentLoaded', initCookieNotice);
